import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useUnassignWorkOrder(callbacks?: QueryCallbacks<null>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["unassignWorkOrder"],
    async (workOrderId: number) => apiContext.assignmentApis.unassignWorkOrder(workOrderId),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
